import {HoobiizWhiteLabelingTheme} from '@shared/dynamo_model';

import {useSession} from '@shared-frontend/lib/session_store';

export function useIsHoobiiz(): boolean {
  const {whiteLabeling} = useSession();
  const theme = whiteLabeling?.theme;
  return theme === undefined || theme === HoobiizWhiteLabelingTheme.Youpiiz;
}
